import { render, staticRenderFns } from "./SideCenterInviteAudience.vue?vue&type=template&id=0350e3a8&scoped=true"
import script from "./SideCenterInviteAudience.vue?vue&type=script&lang=js"
export * from "./SideCenterInviteAudience.vue?vue&type=script&lang=js"
import style0 from "./SideCenterInviteAudience.vue?vue&type=style&index=0&id=0350e3a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0350e3a8",
  null
  
)

export default component.exports